import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form, Input, DatePicker, Checkbox, Divider, Select, Typography } from 'antd'
import type { Tables } from '@muaa/shared'
import { ImageUploadField } from '../../components/ImageUploadField'

type Event = Tables<'events'>

export function EventCreate() {
  const { formProps, saveButtonProps, form } = useForm<Event>()

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical" initialValues={{ is_featured: false, featured_type: 'event' }}>
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Subtitle" name="subtitle">
          <Input />
        </Form.Item>
        <Form.Item label="Start Date" name="start_date">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="End Date" name="end_date">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Location" name="location">
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>

        <Divider orientation="left">Tickets &amp; Payments</Divider>
        <Form.Item
          label="Cheddar Up Ticket URL"
          name="cheddarup_url"
          tooltip="Cheddar Up page for paid tickets; leave blank to hide the Get Tickets button in the app."
        >
          <Input placeholder="https://muaa.cheddarup.com/c/..." />
        </Form.Item>

        <Divider orientation="left">Home Featured Carousel</Divider>
        <Form.Item label="Featured" name="is_featured" valuePropName="checked">
          <Checkbox>Show this event in the mobile Home featured-events carousel</Checkbox>
        </Form.Item>
        <Form.Item
          label="Featured Type"
          name="featured_type"
          tooltip="Announcement → tapping the card opens a full-screen image close-up. Event → tapping opens the event detail screen."
        >
          <Select
            options={[
              { label: 'Announcement (image close-up)', value: 'announcement' },
              { label: 'Event (opens detail screen)', value: 'event' },
            ]}
          />
        </Form.Item>
        {/* No featured_session_id picker on CREATE — a brand-new event cannot
            have sub-events yet (and the DB rejects cross-event links), so
            there is nothing legal to offer. Link one from the Edit page after
            the sub-events exist. */}
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) => prev.featured_type !== cur.featured_type}
        >
          {({ getFieldValue }) =>
            getFieldValue('featured_type') === 'event' ? (
              <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                Link a sub-event after creating it — a new event has no sub-events yet.
              </Typography.Text>
            ) : null
          }
        </Form.Item>
        <ImageUploadField
          form={form}
          name="image_url"
          label="Carousel Image URL"
          tooltip="Hero image on the featured card / the close-up shown for an announcement."
        />
      </Form>
    </Create>
  )
}
